import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import {createI18n} from "vue-i18n";
import {setupCalendar} from "v-calendar";
import {createApp, h} from "vue";
import {createInertiaApp} from "@inertiajs/vue3";
import all from "@frontJs/langs/all.js";
import messages from "@js/langs/fr/messages";

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.moment = require("moment");

const i18n = createI18n({
    legacy: false,
    locale: "fr",
    globalInjection: true,
    messages: {
        fr: { ...messages, all: all.fr },
    }
});

window.i18n = i18n;

createInertiaApp({
    resolve: (name) => require(`./${name}`),
    setup({el, App, props, plugin}) {
        const app = createApp({render: () => h(App, props)})
            .use(plugin)
            .use(Vue3Toastify, {
                position: "top-center",
                autoClose: 3000,
            })
            .use(i18n);

        app.config.globalProperties.$active_route = (activeRoute) => {
            return activeRoute === route().current();
        };

        app.config.globalProperties.route = (name, options) => route(name, options);

        app.use(setupCalendar, {});
        app.mount(el);

        return {app};
    },
    inject: true
});
